// import noUiSlider from 'nouislider';
// import '@archetype-themes/scripts/config';
// import '@archetype-themes/scripts/helpers/currency';
// import '@archetype-themes/scripts/helpers/delegate';

// if (typeof noUiSlider === 'undefined') {
//   throw new Error('theme.PriceRange is missing vendor noUiSlider: // =require vendor/nouislider.js');
// }

// const defaultStep = 1;
// const selectors = {
//   priceRange: '.price-range',
//   priceRangeSlider: '.price-range__slider',
//   priceRangeInputMin: '.price-range__input-min',
//   priceRangeInputMax: '.price-range__input-max',
//   priceRangeDisplayMin: '.price-range__display-min',
//   priceRangeDisplayMax: '.price-range__display-max',
//   filters: '#CollectionSidebarFilterWrap .filter-wrapper',
//   applyButton: '.price-range__apply',
// };

// class PriceRange extends HTMLElement {
//   constructor() {
//     super();
//     this.container = this;
//   }

//   connectedCallback() {
//     if (!theme.filtersPrime) {
//       theme.filtersPrime = document.querySelector(selectors.filters).cloneNode(true);
//     }

//     this.init();
//   }

//   init() {
//     if (!this.container.classList.contains('price-range')) {
//       throw new Error('You must instantiate PriceRange with a valid container')
//     }

//     this.formEl = this.container.closest('form');
//     this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
//     this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
//     this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
//     this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
//     this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

//     this.minRange = parseFloat(this.container.dataset.min) || 0;
//     this.minValue = parseFloat(this.container.dataset.minValue) || 0;
//     this.maxRange = parseFloat(this.container.dataset.max) || 100;
//     this.maxValue = parseFloat(this.container.dataset.maxValue) || this.maxRange;

//     this.applyBtn = this.container.querySelector(
//       selectors.applyButton
//     );

//     this.applyBtn?.addEventListener(
//       'click',
//       this.applyPriceFilter.bind(this)
//     );

//     this.inputMinEl.addEventListener(
//       'change',
//       this.updateSliderFromInputs.bind(this)
//     );

//     this.inputMaxEl.addEventListener(
//       'change',
//       this.updateSliderFromInputs.bind(this)
//     );

//     this.isUpdatingFromInput = false;

//     this.inputMinEl.addEventListener(
//       'input',
//       this.updateSliderFromInputs.bind(this)
//     );

//     this.inputMaxEl.addEventListener(
//       'input',
//       this.updateSliderFromInputs.bind(this)
//     );

//     this.inputMinEl.addEventListener('input', () => {
//   console.log('min input');
// });

// this.inputMinEl.addEventListener('change', () => {
//   console.log('min change');
// });

//     return this.createPriceRange();
//   }

//   updateSliderFromInputs() {
//     this.isUpdatingFromInput = true;

//     const min = Number(this.inputMinEl.value);
//     const max = Number(this.inputMaxEl.value);

//     if (!Number.isNaN(min) && !Number.isNaN(max)) {
//       this.slider.set([min, max]);
//     }

//     this.isUpdatingFromInput = false;
//   }

//   applyPriceFilter() {
//     const formData = new FormData(this.formEl);

//     document.dispatchEvent(
//       new CustomEvent('price-range:change', {
//         detail: formData,
//       })
//     );
//   }

//   createPriceRange() {
//     if (
//       this.sliderEl &&
//       this.sliderEl.noUiSlider &&
//       typeof this.sliderEl.noUiSlider.destroy === 'function'
//     ) {
//       this.sliderEl.noUiSlider.destroy();
//     }

//     this.slider = noUiSlider.create(this.sliderEl, {
//       connect: true,
//       step: defaultStep,
//       start: [this.minValue, this.maxValue],
//       range: {
//         min: this.minRange,
//         max: this.maxRange,
//       },
//     });

//     this.slider.on('update', values => {
//       if (!this.isUpdatingFromInput) {
//         this.inputMinEl.value = Math.round(values[0]);
//         this.inputMaxEl.value = Math.round(values[1]);
//       }

//       this.displayMinEl.innerHTML = theme.Currency.formatMoney(
//         values[0],
//         theme.settings.moneyFormat
//       );

//       this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
//         values[1],
//         theme.settings.moneyFormat
//       );
//     });

//     return this.slider;
//   }
// }

// customElements.define('price-range', PriceRange);


import noUiSlider from 'nouislider';
import '@archetype-themes/scripts/config';
import '@archetype-themes/scripts/helpers/currency';
import '@archetype-themes/scripts/helpers/delegate';

if (typeof noUiSlider === 'undefined') {
  throw new Error('theme.PriceRange is missing vendor noUiSlider: //= require vendor/nouislider.js');
}

const defaultStep = 1;
const selectors = {
  priceRange: '.price-range',
  priceRangeSlider: '.price-range__slider',
  priceRangeInputMin: '.price-range__input-min',
  priceRangeInputMax: '.price-range__input-max',
  priceRangeDisplayMin: '.price-range__display-min',
  priceRangeDisplayMax: '.price-range__display-max',
  filters: '#CollectionSidebarFilterWrap .filter-wrapper',
  applyButton: '.price-range__apply',
};

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.isUpdatingFromInput = false;
    this.isUpdatingFromSlider = false;
    this.inputTimeout = null;
    this.slider = null; // Store slider reference
  }

  connectedCallback() {
    if (!theme.filtersPrime) {
      const filtersEl = document.querySelector(selectors.filters);
      if (filtersEl) {
        theme.filtersPrime = filtersEl.cloneNode(true);
      }
    }

    // Wait for DOM to be fully ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init());
    } else {
      this.init();
    }
  }

  init() {
    if (!this.container.classList.contains('price-range')) {
      throw new Error('You must instantiate PriceRange with a valid container')
    }

    this.formEl = this.container.closest('form');
    this.sliderEl = this.container.querySelector(selectors.priceRangeSlider);
    this.inputMinEl = this.container.querySelector(selectors.priceRangeInputMin);
    this.inputMaxEl = this.container.querySelector(selectors.priceRangeInputMax);
    this.displayMinEl = this.container.querySelector(selectors.priceRangeDisplayMin);
    this.displayMaxEl = this.container.querySelector(selectors.priceRangeDisplayMax);

    // Get values from data attributes or inputs
    this.minRange = parseFloat(this.container.dataset.min) || 0;
    this.maxRange = parseFloat(this.container.dataset.max) || 100;
    
    // Get current values from inputs or data attributes
    this.minValue = parseFloat(this.inputMinEl?.value) || parseFloat(this.container.dataset.minValue) || this.minRange;
    const currentMax = parseFloat(this.inputMaxEl?.value ?? this.container.dataset.maxValue);
    this.maxValue = Number.isFinite(currentMax) ? currentMax : this.maxRange;

    // Set initial input values
    if (this.inputMinEl) this.inputMinEl.value = this.minValue;
    if (this.inputMaxEl) this.inputMaxEl.value = this.maxValue;

    this.applyBtn = this.container.querySelector(selectors.applyButton);

    // Create slider first
    this.createPriceRange();

    // Then attach event listeners
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.applyBtn?.addEventListener(
      'click',
      this.applyPriceFilter.bind(this)
    );

    // Input events for real-time updates
    if (this.inputMinEl) {
      this.inputMinEl.addEventListener(
        'input',
        this.handleInput.bind(this)
      );
      this.inputMinEl.addEventListener(
        'change',
        this.handleInputChange.bind(this)
      );
      this.inputMinEl.addEventListener(
        'blur',
        this.handleInputChange.bind(this)
      );
    }

    if (this.inputMaxEl) {
      this.inputMaxEl.addEventListener(
        'input',
        this.handleInput.bind(this)
      );
      this.inputMaxEl.addEventListener(
        'change',
        this.handleInputChange.bind(this)
      );
      this.inputMaxEl.addEventListener(
        'blur',
        this.handleInputChange.bind(this)
      );
    }
  }

  handleInput() {
    // Clear any pending timeout
    if (this.inputTimeout) {
      clearTimeout(this.inputTimeout);
      this.inputTimeout = null;
    }

    // Update slider in real-time
    this.updateSliderFromInputs(false);
  }

  handleInputChange() {
    // Clear any pending timeout
    if (this.inputTimeout) {
      clearTimeout(this.inputTimeout);
    }

    // Use a small delay to let the input event finish first
    this.inputTimeout = setTimeout(() => {
      this.updateSliderFromInputs(true);
      this.inputTimeout = null;
    }, 10);
  }

  updateSliderFromInputs(shouldClamp = false) {
    // Prevent infinite loops
    if (this.isUpdatingFromSlider || !this.slider) return;
    
    this.isUpdatingFromInput = true;

    let min = parseFloat(this.inputMinEl?.value);
    let max = parseFloat(this.inputMaxEl?.value);

    // Handle empty or invalid values
    if (isNaN(min) || this.inputMinEl?.value === '' || this.inputMinEl?.value === null) {
      min = this.minRange;
      if (this.inputMinEl) this.inputMinEl.value = min;
    }
    
    if (isNaN(max) || this.inputMaxEl?.value === '' || this.inputMaxEl?.value === null) {
      max = this.maxRange;
      if (this.inputMaxEl) this.inputMaxEl.value = max;
    }

    // Clamp values to range
    min = Math.max(this.minRange, Math.min(min, this.maxRange));
    max = Math.max(this.minRange, Math.min(max, this.maxRange));

    // Ensure min doesn't exceed max
    if (min > max) {
      const activeElement = document.activeElement;
      if (activeElement === this.inputMinEl || shouldClamp) {
        // If user is editing min or we're clamping, set min to max
        min = max;
        if (this.inputMinEl) this.inputMinEl.value = min;
      } else if (activeElement === this.inputMaxEl) {
        // If user is editing max, set max to min
        max = min;
        if (this.inputMaxEl) this.inputMaxEl.value = max;
      } else {
        // Default: set both to the same value
        min = Math.min(min, max);
        max = Math.max(min, max);
        if (this.inputMinEl) this.inputMinEl.value = min;
        if (this.inputMaxEl) this.inputMaxEl.value = max;
      }
    }

    // Update slider using noUiSlider's set method
    try {
      this.slider.set([min, max]);
    } catch (error) {
      console.warn('Error setting slider values:', error);
    }

    this.isUpdatingFromInput = false;
  }

  applyPriceFilter() {
    if (!this.formEl) return;
    
    const formData = new FormData(this.formEl);

    document.dispatchEvent(
      new CustomEvent('price-range:change', {
        detail: formData,
      })
    );
  }

  createPriceRange() {
    if (!this.sliderEl) {
      console.warn('Slider element not found');
      return null;
    }

    // Destroy existing slider if it exists
    if (this.slider && typeof this.slider.destroy === 'function') {
      this.slider.destroy();
      this.slider = null;
    }

    // Create new slider
    try {
      this.slider = noUiSlider.create(this.sliderEl, {
        connect: true,
        step: defaultStep,
        start: [this.minValue, this.maxValue],
        range: {
          min: this.minRange,
          max: this.maxRange,
        },
        format: {
          to: function(value) {
            return Math.round(value);
          },
          from: function(value) {
            return parseFloat(value);
          }
        }
      });

      // Update event listener
      this.slider.on('update', (values, handle, unencoded, tap, positions) => {
        // Prevent input updates from triggering slider updates
        if (this.isUpdatingFromInput) return;

        this.isUpdatingFromSlider = true;

        const minValue = Math.round(parseFloat(values[0]));
        const maxValue = Math.round(parseFloat(values[1]));

        // Only update inputs if they're not focused
        if (this.inputMinEl && document.activeElement !== this.inputMinEl) {
          this.inputMinEl.value = minValue;
        }
        
        if (this.inputMaxEl && document.activeElement !== this.inputMaxEl) {
          this.inputMaxEl.value = maxValue;
        }

        // Update display
        if (this.displayMinEl) {
          this.displayMinEl.innerHTML = theme.Currency.formatMoney(
            values[0],
            theme.settings.moneyFormat
          );
        }

        if (this.displayMaxEl) {
          this.displayMaxEl.innerHTML = theme.Currency.formatMoney(
            values[1],
            theme.settings.moneyFormat
          );
        }

        this.isUpdatingFromSlider = false;
      });

      // Apply once a drag, track tap, or keyboard adjustment is committed.
      // The update event above only synchronizes the displayed/input values.
      this.slider.on('change', () => this.applyPriceFilter());

    } catch (error) {
      console.error('Error creating slider:', error);
      return null;
    }

    return this.slider;
  }
}

customElements.define('price-range', PriceRange);